import { Component } from '@angular/core';

@Component({
  selector: 'app-add-recurring-donation',
  templateUrl: './add-recurring-donation.component.html',
  styleUrls: ['./add-recurring-donation.component.scss'],
})
export class AddRecurringDonationComponent {}
